const _temp0 = require("./headers/community_events_header.png");
const _temp1 = require("./headers/driving_school_header.png");
const _temp2 = require("./headers/hardcore_racing_header.png");
const _temp3 = require("./headers/motor_mash_header.png");
const _temp4 = require("./headers/powered_up_racing_header.png");
const _temp5 = require("./headers/skirmish_racing_header.png");
const _temp6 = require("./headers/team_motor_mash_header.png");
const _temp7 = require("./headers/team_racing_header.png");
const _temp8 = require("./headers/world_tour_header.png");
module.exports = {
  "community_events_header": _temp0,
  "driving_school_header": _temp1,
  "hardcore_racing_header": _temp2,
  "motor_mash_header": _temp3,
  "powered_up_racing_header": _temp4,
  "skirmish_racing_header": _temp5,
  "team_motor_mash_header": _temp6,
  "team_racing_header": _temp7,
  "world_tour_header": _temp8
}